import { render, staticRenderFns } from "./HeaderFilter.vue?vue&type=template&id=2354ada8&scoped=true&"
import script from "./HeaderFilter.vue?vue&type=script&lang=js&"
export * from "./HeaderFilter.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFilter.vue?vue&type=style&index=0&id=2354ada8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354ada8",
  null
  
)

export default component.exports